export const instrumentManagementFormCustomRepo = {
  CountryOfIssuance: {
    position: 1,
    value: [
      {
        fieldName: "CountryRegionOfIssuance",
        fieldType: "countryWidget",
        uiConfiguration: [
          {
            displayName: "Country Of Issuance",
            shortName: null,
            sectionName: "Security Registration",
            fieldOrder: 7,
            sectionOrder: 0,
            defaultValue: "",
            hideIfFalseOrEmpty: false,
            userRoles: "All",
            uiInput: "countryWidget",
            displayFormat: null,
            conditions: ["None"],
            cssClass: null,
            widgetSettings: "required=true"
          }
        ],
        settings: [],
        label: "Country Of Issuance"
      }
    ]
  },
  InstrumentTypeCode: {
    position: -1,
    value: [
      {
        fieldName: "instrumentType",
        fieldType: "instrumentWidget",
        uiConfiguration: [
          {
            displayName: "Instrument Type",
            shortName: null,
            sectionName: "Registration Information",
            fieldOrder: 0,
            sectionOrder: 0,
            defaultValue: "",
            hideIfFalseOrEmpty: false,
            userRoles: "All",
            uiInput: "instrumentWidget",
            displayFormat: null,
            conditions: ["None"],
            cssClass: null,
            widgetSettings: null,
            mapToType: "InstrumentType005Enum"
          }
        ],
        settings: [],
        label: "Instrument Type"
      }
    ]
  },
  InstrumentName: {
    position: -1,
    value: [
      {
        fieldName: "issuer",
        fieldType: "issuerWidget",
        uiConfiguration: [
          {
            displayName: "Issuer",
            shortName: null,
            sectionName: "Security Registration",
            fieldOrder: 0,
            sectionOrder: 0,
            defaultValue: "",
            hideIfFalseOrEmpty: false,
            userRoles: "All",
            uiInput: "issuerWidget",
            displayFormat: null,
            conditions: ["None"],
            cssClass: null,
            widgetSettings: null,
            mapToType: "newsCategoryList"
          }
        ],
        settings: [],
        label: "Issuer"
      }
    ]
  }
}

export const customNSM = {
  Symbol: {
    position: -1,
    value: [
      {
        fieldName: "nsm",
        fieldType: "textbox",
        uiConfiguration: [
          {
            displayName: "NSM",
            shortName: null,
            sectionName: "Security Registration",
            fieldOrder: 17,
            sectionOrder: 0,
            defaultValue: "",
            hideIfFalseOrEmpty: false,
            userRoles: "All",
            uiInput: "textbox",
            displayFormat: null,
            conditions: ["None"],
            cssClass: null,
            widgetSettings: null
          }
        ],
        settings: [],
        label: "NSM"
      }
    ]
  }
}

// this gets inserted into model schema on fetch (InstrumentStageModel)
export const customValuesInInstrumentStageSchema = [
  {
    fieldName: "instrumentType",
    fieldType: "instrumentWidget",
    uiConfiguration: [
      {
        displayName: "Instrument Type",
        shortName: null,
        sectionName: "Start Screen",
        fieldOrder: 100,
        sectionOrder: 0,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "instrumentWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "InstrumentType005Enum"
      }
    ],
    settings: [],
    label: "Instrument Type"
  },
  {
    fieldName: "product",
    fieldType: "productWidget",
    uiConfiguration: [
      {
        displayName: "Product",
        shortName: null,
        sectionName: "Product Information",
        fieldOrder: 100,
        sectionOrder: 100,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "productWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "productWidget"
      }
    ],
    settings: [],
    label: "Product"
  },
  {
    fieldName: "contact",
    fieldType: "contactWidget",
    uiConfiguration: [
      {
        displayName: "Contact Information",
        shortName: null,
        sectionName: "Contact Information",
        fieldOrder: 100,
        sectionOrder: 200,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "contactWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "contactWidget"
      }
    ],
    settings: [],
    label: "Contact Information"
  },
  {
    fieldName: "document",
    fieldType: "documentWidget",
    uiConfiguration: [
      {
        displayName: "Supporting Documentation",
        shortName: null,
        sectionName: "Supporting Documentation",
        fieldOrder: 100,
        sectionOrder: 300,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "documentWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "documentWidget"
      }
    ],
    settings: [],
    label: "Supporting Documentation"
  },
  {
    fieldName: "expense",
    fieldType: "expenseWidget",
    uiConfiguration: [
      {
        displayName: "Expense Manager",
        shortName: null,
        sectionName: "Expense Manager",
        fieldOrder: 100,
        sectionOrder: 400,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "expenseWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "expenseWidget"
      }
    ],
    settings: [],
    label: "Expense Manager"
  },
  {
    fieldName: "deletionInformation",
    fieldType: "deletionWidget",
    uiConfiguration: [
      {
        displayName: "Deletion Information",
        shortName: null,
        sectionName: "Deletion Information",
        fieldOrder: 100,
        sectionOrder: 500,
        defaultValue: "",
        hideIfFalseOrEmpty: false,
        userRoles: "All",
        uiInput: "deletionWidget",
        displayFormat: null,
        conditions: ["None"],
        cssClass: null,
        widgetSettings: null,
        mapToType: "deletionWidget"
      }
    ],
    settings: [],
    label: "Expense Manager"
  }
]

// these fields will be clearable on the dropdowns
export const instrumentClearableFields = ["instrumentClassDescription"]

// these sections are view only on the instrument deletion - used for css magic
export const deletionViewOnlySections = ["Security Registration", "Registration Information", "Investment Information"]

// ! Check twice before changing default fields
export const instrumentDefaultFields = [
  "instrumentCategory",
  "issuer",
  "contact",
  "expense",
  "product",
  "deletionInformation",
  "deletionFields",
  "addedDocumentRows",
  "deletedDocumentRows",
  "pricingContactCurrentList",
  "pricingContactFutureList",
  "listingContactCurrentList",
  "listingContactFutureList"
]

// these keys won't be wiped from formState when update field rendering is called
export const instrumentFormStateMandatoryKeys = [
  "applicationId",
  "nsm",
  "instrumentStageId",
  "applicationType",
  "status",
  "deletionFields",
  "test",
  "instrumentId",
  "listingTier"
]

// instrument date only fields
export const InstrumentDateOnlyFields = [
  "ssriRecordDate",
  "effectiveDate",
  'lastUpdatedDate',
  'firstCreatedDate',
  "inceptionDate",
  "numberOfShareholdersDate",
  "totalSharesDate",
  "totalNetAssetsDate",
  "navInceptionDate",
  "shareClassLaunchDate",
  "corporateActionDate",
  "depositDate",
  "terminationDate",
  "lastPrimaryTradeDate",
  "closedDate",
  "secondaryDate",
  "authorizedSharesDate"
]

export const InstrumentBooleanFields = [
  "modelPortfolio",
  "excludeFromDistribution",
  "is529",
  "pending",
  "test"
]

export const instrumentAllowedFields = [
  {
    instrumentTypeName: "Mutual Fund",
    instrumentTypeCode: "MF",
    checkInstrumentCategory: true,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",
      "is529",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "isSSRI",
      "SSRI",
      "ssriRecordDate",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "newspaperCategoryId",
      "newspaperAbbreviation",
      "pricingFrequency",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "minimalInitialSubscriptionInShares",
      "minimalSubsequentSubscriptionInShares",
      "frequencyOfSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ],
    CLOSED: ["listingExchangeCode", "listingExchangeSymbol"],
    OPEN: []
  },
  {
    // money market fund
    instrumentTypeName: "Money Market Fund",
    instrumentTypeCode: "MM",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",
      "is529",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "newspaperAbbreviation",
      "pricingFrequency",
      "investorType",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "minimalInitialSubscriptionInShares",
      "minimalSubsequentSubscriptionInShares",
      "frequencyOfSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    // unit investment trust
    instrumentTypeName: "Unit Investment Trust",
    instrumentTypeCode: "UT",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",
      "is529",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "depositDate",
      "terminationDate",
      "lastPrimaryTradeDate",
      "closedDate",
      "parValuePerUnit",
      "secondaryDate",
      "uitStatus",
      "productTerm",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "initialOfferPrice",
      "initialAdvisory",
      "initialLiquidationPrice",
      "minimumInitialIra",
      "product",
      "document",
      "suggestedPrice",
      "uitInvestingCode",
      "seriesCode",
      "sponsorSymbol",
      "sponsorInternalCode",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Annuity",
    instrumentTypeCode: "AN",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Structured Product",
    instrumentTypeCode: "SP",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "depositDate",
      "terminationDate",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Alternate Investment Product",
    instrumentTypeCode: "AP",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "depositDate",
      "terminationDate",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Hedge Fund",
    instrumentTypeCode: "HF",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "depositDate",
      "terminationDate",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "nsccClearingEligible",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Private Stock",
    instrumentTypeCode: "EM",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "openForNewInvestors",
      "navInceptionDate",
      "initialNetAssets",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate",
      "authorizedShares",
      "authorizedSharesDate"
    ]
  },
  {
    instrumentTypeName: "Managed Account",
    instrumentTypeCode: "MA",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "instrumentPerformance",
      "rebalanceFrequency",
      "inceptionDate",
      "openForNewInvestors",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "numberOfAccounts",
      "numberOfAccountsDate",
      "gipsCompliant",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Collective Investment Trust",
    instrumentTypeCode: "CT",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "openForNewInvestors",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "gipsCompliant",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Separate Account",
    instrumentTypeCode: "SA",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "instrumentPerformance",
      "rebalanceFrequency",
      "inceptionDate",
      "openForNewInvestors",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "numberOfAccounts",
      "numberOfAccountsDate",
      "gipsCompliant",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  },
  {
    instrumentTypeName: "Demand Deposit Account",
    instrumentTypeCode: "DD",
    checkInstrumentCategory: false,
    default: [
      "instrumentType",
      "issuer",
      "instrumentName",
      "instrumentClassDescription",

      "countryRegionOfIssuance",
      "vehicleLegalStructureId",
      "CUSIP",
      "ISIN",
      "FIGI",
      "effectiveDate",
      "nSM",
      "symbol",
      "registrationBody",
      "excludeFromDistribution",

      "modelPorfolio",
      "pricingFrequency",
      "investorType",
      "distributionType",
      "distributionFrequency",
      "inceptionDate",
      "numberOfShareholders",
      "numberOfShareholdersDate",
      "totalSharesOutstanding",
      "totalSharesDate",
      "totalNetAssets",
      "totalNetAssetsDate",
      "openForNewInvestors",
      "navInceptionDate",
      "initialNetAssets",
      "initialSubscription",
      "incrementalSubscription",
      "insured",
      "insuredAmount",
      "product",
      "document",
      "suggestedPrice",
      "shareClassLaunchDate",
      "corporateActionDate"
    ]
  }
]

export const ApplicationTypeLabels = {
  NEWAPP: "New",
  DELETE: "Delete",
  RSTORE: "Restore",
  GCHNGE: "Attribute Change",
  UITREP: "Replacemenet"
}
